/**
 * Options used to control default behaviors regarding compatibility support
 */
export class CompatibilityOptions {
    /**
     * Defines if the system should use OpenGL convention for UVs when creating geometry or loading .babylon files (false by default)
     */
    public static UseOpenGLOrientationForUV = false;
}
